const VALIDATION_MESSAGES = {
  "woodstoveInsertPreTestConditionsPrimary_yesOrNo1": "Please select just one option: yes or no (pre-test, primary, 1)",
  "woodstoveInsertPreTestConditionsPrimary_yesOrNo2": "Please select just one option: yes or no (pre-test, primary, 2)",
  "woodstoveInsertPreTestConditionsPrimary_yesOrNo3": "Please select just one option: yes or no (pre-test, primary, 3)",
  "woodstoveInsertPreTestConditionsPrimary_yesOrNo4": "Please select just one option: yes or no (pre-test, primary, 4)",

  "woodstoveInsertPreTestConditionsSecondary_yesOrNo1": "Please select just one option: yes or no (pre-test, secondary, 1)",
  "woodstoveInsertPreTestConditionsSecondary_yesOrNo2": "Please select just one option: yes or no (pre-test, secondary, 2)",
  "woodstoveInsertPreTestConditionsSecondary_yesOrNo3": "Please select just one option: yes or no (pre-test, secondary, 3)",
  "woodstoveInsertPreTestConditionsSecondary_yesOrNo4": "Please select just one option: yes or no (pre-test, secondary, 4)",


  "woodstoveInsertPostTestConditionsPrimary_yesOrNo1": "Please select just one option: yes or no (post-test, primary, 1)",
  "woodstoveInsertPostTestConditionsPrimary_yesOrNo2": "Please select just one option: yes or no (post-test, primary, 2)",
  "woodstoveInsertPostTestConditionsPrimary_yesOrNo3": "Please select just one option: yes or no (post-test, primary, 3)",
  "woodstoveInsertPostTestConditionsPrimary_yesOrNo4": "Please select just one option: yes or no (post-test, primary, 4)",

  "woodstoveInsertPostTestConditionsSecondary_yesOrNo1": "Please select just one option: yes or no (post-test, secondary, 1)",
  "woodstoveInsertPostTestConditionsSecondary_yesOrNo2": "Please select just one option: yes or no (post-test, secondary, 2)",
  "woodstoveInsertPostTestConditionsSecondary_yesOrNo3": "Please select just one option: yes or no (post-test, secondary, 3)",
  "woodstoveInsertPostTestConditionsSecondary_yesOrNo4": "Please select just one option: yes or no (post-test, secondary, 4)",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "woodstoveInsertPreTestPrimaryConditions1_yes": () => ({ validate: () => {
        const yesOrNo = ["woodstoveInsertPreTestPrimaryConditions1_yes", "woodstoveInsertPreTestPrimaryConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPreTestConditionsPrimary_yesOrNo1'];
      },
    }),
    "woodstoveInsertPreTestPrimaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPreTestPrimaryConditions2_yes", "woodstoveInsertPreTestPrimaryConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPreTestConditionsPrimary_yesOrNo2'];
      },
    }),
    "woodstoveInsertPreTestPrimaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPreTestPrimaryConditions3_yes", "woodstoveInsertPreTestPrimaryConditions3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPreTestConditionsPrimary_yesOrNo3'];
      },
    }),
    "woodstoveInsertPreTestPrimaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPreTestPrimaryConditions4_yes", "woodstoveInsertPreTestPrimaryConditions4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPreTestConditionsPrimary_yesOrNo4'];
      },
    }),

    "woodstoveInsertPreTestSecondaryConditions1_yes": () => ({ validate: () => {
        const yesOrNo = ["woodstoveInsertPreTestSecondaryConditions1_yes", "woodstoveInsertPreTestSecondaryConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPreTestConditionsSecondary_yesOrNo1'];
      },
    }),
    "woodstoveInsertPreTestSecondaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPreTestSecondaryConditions2_yes", "woodstoveInsertPreTestSecondaryConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPreTestConditionsSecondary_yesOrNo2'];
      },
    }),
    "woodstoveInsertPreTestSecondaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPreTestSecondaryConditions3_yes", "woodstoveInsertPreTestSecondaryConditions3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPreTestConditionsSecondary_yesOrNo3'];
      },
    }),
    "woodstoveInsertPreTestSecondaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPreTestSecondaryConditions4_yes", "woodstoveInsertPreTestSecondaryConditions4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPreTestConditionsSecondary_yesOrNo4'];
      },
    }),

    // post test 
    "woodstoveInsertPostTestPrimaryConditions1_yes": () => ({ validate: () => {
        const yesOrNo = ["woodstoveInsertPostTestPrimaryConditions1_yes", "woodstoveInsertPostTestPrimaryConditions1_no", "woodstoveInsertPostTestPrimaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPostTestConditionsPrimary_yesOrNo1'];
      },
    }),
    "woodstoveInsertPostTestPrimaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPostTestPrimaryConditions3_yes", "woodstoveInsertPostTestPrimaryConditions3_no", "woodstoveInsertPostTestPrimaryConditions3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPostTestConditionsPrimary_yesOrNo3'];
      },
    }),
    "woodstoveInsertPostTestPrimaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPostTestPrimaryConditions4_yes", "woodstoveInsertPostTestPrimaryConditions4_no", "woodstoveInsertPostTestPrimaryConditions4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPostTestConditionsPrimary_yesOrNo4'];
      },
    }),

    "woodstoveInsertPostTestSecondaryConditions1_yes": () => ({ validate: () => {
        const yesOrNo = ["woodstoveInsertPostTestSecondaryConditions1_yes", "woodstoveInsertPostTestSecondaryConditions1_no", "woodstoveInsertPostTestSecondaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPostTestConditionsSecondary_yesOrNo1'];
      },
    }),
    "woodstoveInsertPostTestSecondaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPostTestSecondaryConditions3_yes", "woodstoveInsertPostTestSecondaryConditions3_no", "woodstoveInsertPostTestSecondaryConditions3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPostTestConditionsSecondary_yesOrNo3'];
      },
    }),
    "woodstoveInsertPostTestSecondaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["woodstoveInsertPostTestSecondaryConditions4_yes", "woodstoveInsertPostTestSecondaryConditions4_no", "woodstoveInsertPostTestSecondaryConditions4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['woodstoveInsertPostTestConditionsSecondary_yesOrNo4'];
      },
    }),
  };
};

export default useValidation;
